import * as yup from "yup";
const phoneRegExp = /^(010|011|012|015)\d{8}$/;
const emailRegExp = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g;

export const EnSchema = yup.object().shape({
  username: yup
    .string()
    .min(3, "Username must be at least 3 characters long")
    .required("Required"),
  email: yup
    .string()
    .matches(emailRegExp, "Please enter a valid email")
    .required("Required"),
  phoneNumber: yup
    .string()
    .matches(
      phoneRegExp,
      "Phone number must start with (010/011/012/015) directly"
    )
    .min(11, "Must be exactly 11 digits")
    .max(11, "Must be exactly 11 digits")
    .required("Required"),
  subject: yup.string().required("Required"),
  message: yup.string().required("Required"),
});
